import React from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { format, parseISO } from 'date-fns'
import ReactMarkdown from 'react-markdown'
import { termsActions, termsSelectors } from './redux'
import { sessionActions } from '../session/redux'
import './TermsAcceptanceModal.css'

const formatPublishedAt = (iso) => {
    if (!iso) return ''
    try {
        return format(parseISO(iso), 'yyyy-MM-dd')
    } catch (e) {
        return iso
    }
}

const TermsAcceptanceModal = ({ status, currentDocument, accepting, error, onAccept, onLogout }) => (
    <Modal
        show={true}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
        aria-labelledby="terms-title"
        aria-describedby="terms-intro"
        aria-modal="true"
        autoFocus
        enforceFocus
        restoreFocus
        lang="sv"
    >
        <Modal.Header>
            <Modal.Title id="terms-title"><h3>Användarvillkor</h3></Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {currentDocument ? (
                <>
                    <p id="terms-intro" className="TermsAcceptanceModal-intro">
                        För att fortsätta använda Ögonremiss behöver du läsa och godkänna användarvillkoren.
                    </p>
                    <p className="TermsAcceptanceModal-version">
                        Version {currentDocument.version}, publicerad {formatPublishedAt(currentDocument.publishedAt)}.
                    </p>
                    <div
                        role="region"
                        aria-label="Användarvillkor"
                        tabIndex={0}
                        className="TermsAcceptanceModal-scroll"
                    >
                        <ReactMarkdown
                            skipHtml
                            disallowedElements={['script', 'iframe', 'style']}
                            components={{
                                h1: 'h3', h2: 'h4', h3: 'h5', h4: 'h6',
                            }}
                        >
                            {currentDocument.body}
                        </ReactMarkdown>
                    </div>
                </>
            ) : (
                <p>Laddar villkor...</p>
            )}
            {error && (
                <div role="alert" className="TermsAcceptanceModal-error">
                    {error}
                </div>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline-secondary" onClick={onLogout} disabled={accepting}>
                Logga ut
            </Button>
            <Button
                variant="primary"
                onClick={() => currentDocument && onAccept(currentDocument.id)}
                disabled={accepting || !currentDocument}
                aria-busy={accepting}
            >
                {accepting
                    ? <><Spinner size="sm" animation="border" className="me-1"/> Sparar...</>
                    : 'Jag accepterar användarvillkoren'}
            </Button>
        </Modal.Footer>
    </Modal>
)

const mapStateToProps = (state) => ({
    status: termsSelectors.status(state),
    currentDocument: termsSelectors.currentDocument(state),
    accepting: termsSelectors.accepting(state),
    error: termsSelectors.error(state),
})

const mapDispatchToProps = (dispatch) => ({
    onAccept: (termsDocumentId) => dispatch(termsActions.acceptTerms(termsDocumentId)),
    onLogout: () => dispatch(sessionActions.logOut()),
    fetchCurrent: () => dispatch(termsActions.fetchCurrent()),
})

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle({
        componentDidMount() {
            if (!this.props.currentDocument) {
                this.props.fetchCurrent();
            }
        },
    }),
)(TermsAcceptanceModal)
